import {
  InfoModule,
  createInfoServices
} from "./chunk-5LQGOBIZ.mjs";
import "./chunk-CDQIA6O3.mjs";
export {
  InfoModule,
  createInfoServices
};
